module.exports = __webpack_public_path__ + "static/media/layer.3e60c1ce.svg";